import * as React from 'react';
import * as styles from './ServicesLayout.css';

interface IServicesLayoutProps {
  services: React.ReactNode;
  error: React.ReactNode;
}

export const ServicesLayout = ({ services, error }: IServicesLayoutProps) => {
  return (
    <div className={styles['container']}>
      {services}
      {error && <div className={styles['error']}>{error}</div>}
    </div>
  );
};
